<template>
    <v-container fluid>
    <v-row class="mt-1" justify="center">
      <v-col cols="6">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="selectedMonth"
            label="Select a month"
            readonly
            v-bind="attrs"
            v-on="on"
          >
          <template v-slot:prepend>
            <v-icon>mdi-calendar</v-icon>
          </template>          
        </v-text-field>
        </template>
        <v-list>
          <v-list-item
            v-for="month in availableMonths"
            :key="month.value"
            @click="selectedMonth = month.text; fetchPdf()"
          >
            <v-list-item-title>{{ month.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
      <v-col  class="d-flex justify-center" cols="6">
        <v-btn 
        v-model="mode" 
        @click="toggleMode"
        rounded
        color="primary"
        dark
        >
          {{ mode ? 'Continuous mode' : 'Page by mode' }}
        </v-btn>
        <!-- NO PAGES:{{ numPages }} -->       
    <!-- Dropdown to select a page -->
      <!-- <v-select v-model="currentPage" :disabled="!pdfLoaded" :items="pageOptions" :label="page">
        <template v-slot:prepend>
         <v-text>PAGE</v-text>
        </template>
        <template v-slot:append>
         <v-text>/ {{ numPages }}</v-text>
        </template>
      </v-select> -->
      </v-col>
    </v-row>
    
    <v-row class="mt-2" v-if="pdfLoaded">
      <v-col v-if="mode">
      <v-responsive :aspect-ratio="getAspectRatio()">
        <!-- <pdf :src="pdfSrc" /> -->
        <pdf 
        :src="pdfSrc" 
        :page="currentPage" />
      </v-responsive> 
      </v-col>
      <v-col v-else>
        <v-responsive :aspect-ratio="getAspectRatio()">
        <pdf  
          v-for="page in numPages"
          :key="page"
          :src="pdfSrc"
          :page="page"
        />
      </v-responsive>
      </v-col>            
    </v-row>
    <v-row v-if="mode"  
    justify="space-around">
    <v-col class="d-flex" cols="4">
      <v-btn :disabled="currentPage === 1" @click="previousPage" color="primary">Previous</v-btn>     
    </v-col>  
    <v-col class="d-flex justify-center" cols="4">
      <v-autocomplete
        filled
        dense
        v-model="currentPage"
        :disabled="!pdfLoaded" 
        :items="pageOptions"
        outlined
        style="max-weight:50px"
      >
      <template v-slot:append>
          {{`/   ${numPages}`  }}
      </template>
      </v-autocomplete>
      <!-- <v-select v-model="currentPage" :disabled="!pdfLoaded" :items="pageOptions" :label="page">
        <template v-slot:append>
         <v-text>/ {{ numPages }}</v-text>
        </template>
      </v-select> -->
    </v-col> 
    <v-col class="d-flex justify-end" cols="4">     
      <v-btn :disabled="currentPage === numPages" @click="nextPage" color="primary">Next</v-btn>
    </v-col> 
    </v-row>
  </v-container>
</template>

<script>
import secure_axios from "../services/secure_axios";
import pdf from 'vue-pdf'
import { PDFDocument } from 'pdf-lib';
import moment from 'moment' // Using moment.js for date formatting
export default {
  components: {
      pdf
  },
  data() {
    return {
      pdfUrl: null,
      pdfSrc: null,
      selectedDate: null,
      maxDate: null,
      selectedMonth: moment().format('MMM YYYY'),
      previousMonths: [],
      availableMonths: [],
      pdfLoaded: false,
      numPages: 0,
      currentPage: 1,
      mode: false,
    };
  },
  computed: {
    sessionAPI() {
      return this.$store.getters.sessionAPI
    },
    pageOptions() {
      const pageOptions = [];
      for (let i = 1; i <= this.numPages; i++) {
        pageOptions.push(i);
      }
      return pageOptions;
    },
  },
  mounted() {
    this.selectedDate = moment().format('YYYY-MM-DD');
    this.maxDate = moment().format('YYYY-MM-DD');
    this.generatePreviousMonths();
    this.fetchPdf();
  },
  methods: {
    generatePreviousMonths() {
        // Start from a specific date, Aug 2023 in this case.
        const startDate = moment('2023-08-01'); 

        // Add the current month if it's later than the start date
        const today = moment();
        if (today.isSameOrAfter(startDate, 'month')) {
            this.availableMonths.push({
            text: today.format('MMM YYYY'),
            value: today.format('MMMYYYY').toLowerCase()
            });
        }

        let loopDate = moment(startDate);
        while(loopDate.isBefore(today, 'month')) {
            this.availableMonths.push({
            text: loopDate.format('MMM YYYY'),
            value: loopDate.format('MMMYYYY').toLowerCase()
            });
            loopDate.add(1, 'month');
        }
        
        // Sort the array so the latest month comes first
        this.availableMonths.sort((a, b) => {
            return moment(b.value, 'MMMYYYY').valueOf() - moment(a.value, 'MMMYYYY').valueOf();
        });
    },
    // fetchPdf() {
    //   // Adding selectedDate to the API request parameters
    //   secure_axios.get(this.sessionAPI + "editorialpdf", {
    //     params: {
    //     //   employ_id: this.employ_id,
    //       date: this.selectedMonth
    //     },
    //     responseType: 'blob',
    //   })
    //     .then(response => {
    //       const url = window.URL.createObjectURL(new Blob([response.data]));
    //       this.pdfUrl = url;
    //       this.pdfSrc = url;
    //       this.pdfLoaded = true;
    //     })
    //     .catch(error => {
    //       console.log('Error fetching PDF:', error);
    //     });
    // },
    async fetchPdf() {
      try {
        const response = await secure_axios.get(this.sessionAPI + "editorialpdf", {
          params: {
            date: this.selectedMonth
          },
          responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        this.pdfUrl = url;
        this.pdfSrc = url;
        this.pdfLoaded = true;

        // Get page count
        const pdfBlob = await response.data.arrayBuffer();
        this.numPages = await this.getPageCount(pdfBlob);
      } catch (error) {
        console.log('Error fetching PDF:', error);
      }
    },
    async getPageCount(pdfFile) {
      const pdfDoc = await PDFDocument.load(pdfFile);
      return pdfDoc.getPageCount();
    },
    previousPage() {
      this.currentPage--;
    },
    nextPage() {
      this.currentPage++;
    },
    toggleMode() {
      this.mode = !this.mode;
    },
    getAspectRatio() {
      // Adjust the aspect ratio based on the screen orientation
        return this.$vuetify.breakpoint.smAndDown ? 16 / 9 : 4 / 3;
    },
    beforeDestroy() {
      if (this.pdfRender && this.pdfRender.cancel) {
        this.pdfRender.cancel();
      }
    },
  }
};
</script>